// İSG uzmanı portalı — KKD (Kişisel Koruyucu Donanım) kataloğu TanStack Query anahtarları
// (api-contract §24, tenant-scoped). Liste anahtarı parametreleri içerir (filtre/sayfa değişince
// yeniden çeker); invalidasyon önek (prefix) ile: `['protective-equipment','list']` tüm liste
// sorgularını kapsar. `options` = permit-tipi formundaki KKD seçicisini besleyen tek-sayfa çekim.
//
// Katalog erişimi İş İzni Tipleri (§22) ile **aynı grant** altındadır (`permit-types`; D3) — bu yüzden
// ayrı erişim sondası yoktur; katalog ekranları `usePermitTypesAccess` (permitTypesAccess.ts) kapısı
// altındadır.

import type { ProtectiveEquipmentListParams } from '@isgportal/shared';

export const protectiveEquipmentKeys = {
  /** Tüm KKD sorgularının kök öneki — invalidasyon için. */
  all: () => ['protective-equipment'] as const,
  /** Tüm liste sorgularının öneki (filtre/sayfa varyantlarını kapsar). */
  list: () => ['protective-equipment', 'list'] as const,
  /** Sayfalı + filtreli liste — parametreli. */
  listParams: (params: ProtectiveEquipmentListParams) =>
    ['protective-equipment', 'list', params] as const,
  /** Permit-tipi formundaki KKD seçicisi için katalog (tek sayfa). */
  options: () => ['protective-equipment', 'options'] as const,
} as const;
